import Case from "case";
import { TypographyMedium, TypographyType, typographyMap } from "../constants/typographyMap";

const getTypography = (type: TypographyType, medium: TypographyMedium) => {
  const typography = typographyMap[type][TypographyMedium.Common];
  /* @ts-expect-error ts does not like when objects are not complete... */
  const mediumTypography = (typographyMap[type][medium] || {}) as Record<string, string>;
  return { ...typography, ...mediumTypography };
};

const convertToCss = (typography: Record<string, string>, typeName: "mobile" | "desktop") => {
  return Object.entries(typography).map(([key, value]) => `--${typeName}-${Case.kebab(key)}: var(${value});`);
};

export const getTypographyCss = (mobileType: TypographyType, desktopType: TypographyType) => {
  const mobileTypography = getTypography(mobileType, TypographyMedium.Mobile);
  const desktopTypography = getTypography(desktopType, TypographyMedium.Desktop);

  return [
    ...convertToCss(mobileTypography, "mobile"),
    ...convertToCss(desktopTypography, "desktop")
  ].join("\n");
};
